import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/**
 * Hook to detect if the device has a physical keyboard
 * @returns {boolean}
 */
export const useHasPhysicalKeyboard = () => {
  const $ = _c(2);
  const [hasPhysicalKeyboard, setHasPhysicalKeyboard] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const isTouchDevice = "ontouchstart" in window || navigator.maxTouchPoints > 0;
      const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setHasPhysicalKeyboard(!isTouchDevice && !isMobileDevice);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return hasPhysicalKeyboard;
};